import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
// import { ChevronDownIcon } from "@heroicons/react/solid";
import { packClasses } from "Utils";

export default function SegmentedMenu({ label, menuItems, ...remainder }) {
    const variants = {
        primary: "text-white hover:bg-green-700",
        secondary: "text-gray-700 hover:bg-gray-50",
        primaryParent: "border-transparent bg-green-600",
        secondaryParent: "border-gray-300 bg-white",
    };

    let variant;
    let parentVariant;
    switch (remainder.variant) {
        case "primary":
            variant = variants.primary;
            parentVariant = variants.primaryParent;
            break;
        case "secondary":
        default:
            variant = variants.secondary;
            parentVariant = variants.secondaryParent;
    }

    return (
        <div
            disabled={remainder.disabled}
            className={packClasses(
                "flex w-full justify-between rounded-md",
                parentVariant,
                remainder.className
            )}
        >
            <div
                className={packClasses(
                    "focus:outline-none flex-grow rounded-tl-md rounded-bl-md border-r border-green-700 px-4 py-2  align-middle  text-sm font-medium shadow-sm focus:ring-2 focus:ring-green-500 focus:ring-offset-2 focus:ring-offset-gray-100",
                    "z-10 cursor-pointer disabled:opacity-50",
                    variant
                )}
            >
                {label}
            </div>
            <Menu as="div">
                {({ open }) => (
                    <Fragment>
                        <Menu.Button
                            className={packClasses(
                                "h-full rounded-tr-md rounded-br-md px-3 align-middle text-sm font-medium  shadow-sm",
                                "disabled:opacity-50",
                                variant
                            )}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth={2}
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M19 9l-7 7-7-7"
                                />
                            </svg>
                        </Menu.Button>
                        <Transition
                            show={open}
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                        >
                            <Menu.Items
                                static
                                className="focus:outline-none absolute left-0 z-10 mt-2 w-56 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5"
                            >
                                <div className="py-1">
                                    {menuItems.map((child, i) => (
                                        <Menu.Item key={i}>
                                            {({ active }) => (
                                                <div
                                                    className={packClasses(
                                                        active
                                                            ? "bg-gray-100 text-gray-900"
                                                            : "text-gray-700",
                                                        "block cursor-pointer px-4 py-2 text-sm"
                                                    )}
                                                >
                                                    {child}
                                                </div>
                                            )}
                                        </Menu.Item>
                                    ))}
                                </div>
                            </Menu.Items>
                        </Transition>
                    </Fragment>
                )}
            </Menu>
        </div>
    );
}
